import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    text: 'Descarga el manual y lee los fundamentos de Gracia Somática.'
  }, {
    num: '02',
    text: 'Aplica el Protocolo CES de 3 minutos mañana mismo antes de tocar el suelo.'
  }, {
    num: '03',
    text: 'Sigue el plan de 7 días para reconfigurar tu respuesta biológica al despertar.'
  }];
  return <section className="py-12 md:py-14 px-6 bg-white" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <FadeIn data-id="element-73">
          <h2 className="font-serif text-2xl md:text-3xl text-navy mb-8 text-center" data-id="element-74">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 relative" data-id="element-75">
          <div className="hidden md:block absolute top-6 left-1/6 right-1/6 h-px bg-divider z-0" data-id="element-76"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.15} className="relative z-10" data-id="element-77">
              <div className="flex flex-col items-center text-center" data-id="element-78">
                <div className="w-12 h-12 rounded-full bg-cream border-2 border-gold flex items-center justify-center mb-3 shadow-sm" data-id="element-79">
                  <span className="font-serif text-lg text-gold" data-id="element-80">
                    {step.num}
                  </span>
                </div>
                <p className="text-sm md:text-base text-navy/80 leading-relaxed px-2" data-id="element-81">
                  {step.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}